export default {

	// teamCommitments store
	teamCommitments_initializationError: "An error occurred initializing the team action items store: {message}.",
	teamCommitments_fetchMetadataError: "An error occurred fetching action item counts: {message}.",
	teamCommitments_pageCommitmentsError: "An error occurred paging action items: {message}.",
	teamCommitments_updateCommitmentError: "An error occurred updating the action item: {message}.",
};



// WEBPACK FOOTER //
// ./src/lang/en/store.js